import React from 'react'
import NativeDateField from './NativeDateField'

const DateComponent = (props) => {
    return <NativeDateField type="date" {...props} />
}

export default DateComponent
